import { render, staticRenderFns } from "./JobReminderCriterion.vue?vue&type=template&id=41ebe96a&"
import script from "./JobReminderCriterion.vue?vue&type=script&lang=js&"
export * from "./JobReminderCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports